module.exports = __webpack_public_path__ + "img/EEG@2x.4892e360.png";